import React, { useState, useContext } from "react";
import { Form, Button, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import api from "../../api/candidate.resource";
import { CANDIDATE_STATUS, ROLES } from "../../constants/constants";
import { UserContext } from "../context/UserContext";
import CDK_GLOBAL_CIRCULAR_LOGO from "../../images/CDK-Circular-Logo.png";
import TACarousel from "./TACarousel";
import useValidation from "../../util/useValidation";

import "../../styles/login.css";

export const Login = ({ history }) => {
  const [userCredentials, setUserCredentials] = useState({
    userName: "",
    userPassword: ""
  });
  const [loginError, setLoginError] = useState();
  const { handleOnBlurValidation, errors } = useValidation();
  const { setUserDetails } = useContext(UserContext);
  const handleOnChangeInput = e => {
    const { name, value } = e.target;
    setUserCredentials(prevState => ({
      ...prevState,
      [name]: value
    }));
    setLoginError("");
  };

  const handOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  const storeUserData = ({
    userName = "",
    roleId = "",
    token = "",
    fullName = "",
    id = ""
  }) => {
    window.sessionStorage.setItem(
      "user",
      JSON.stringify({ userName, roleId, token, fullName, id })
    );
    setUserDetails({ userName, roleId, id });
  };
  const handleOnSubmitLogin = async e => {
    try {
      e.preventDefault();
      const { userName, userPassword } = userCredentials;
      const res = await api.loginUser({ userName, userPassword });
      if (res) {
        if (res.errorMessage) {
          setLoginError(res.errorMessage);
        } else {
          storeUserData(res);
          const userRoleID = res.roleId;
          const statusID = res.status && res.status.statusCode;
          const candidateId = res.id;
          const isTempPassword = res.isTempPassword;
          const isPasswordExpired = res.isPasswordExpired;
          if (isPasswordExpired) {
            if (isTempPassword) {
              setLoginError("Password is expired.Please contact CDK Global");
            } else {
              history.push("/ChangePassword");
            }
            return;
          }
          if (isTempPassword) {
            history.push("/ChangePassword");
          } else {
            if (
              [ROLES.ADMIN, ROLES.HROPS, ROLES.RECRUITER].includes(userRoleID)
            ) {
              history.push("/CandidateList");
            } else if (
              userRoleID === ROLES.CANDIDATE &&
              statusID >= CANDIDATE_STATUS.ONBOARDING.id
            ) {
              history.push({
                pathname: "/OnboardingForms",
                state: {
                  candidateId,
                  userStatus: statusID
                }
              });
            } else if (userRoleID === ROLES.CANDIDATE) {
              history.push({
                pathname: "/CandidateForm",
                state: {
                  candidateId
                }
              });
            } else {
              setLoginError("InValid Role");
            }
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const isSubmitDisabled = () => {
    const { userName, userPassword } = userCredentials;
    return !userName || !userPassword;
  };

  return (
    <Container className="login-pages-container">
      <TACarousel />
      <div className="login-controls-container">
        <div className="login-controls">
          <img
            className="cdk-circular-logo"
            src={CDK_GLOBAL_CIRCULAR_LOGO}
            alt="CDKGlobalCircularLogo"
          />
          <h4 className="font-weight-bold">CDK TA Portal</h4>
          <p className="font-weight-bold">Login to your TA Portal site</p>
          <Form noValidate onSubmit={handleOnSubmitLogin}>
            <div className="login">
              <Form.Control
                size="lg"
                type="text"
                id="userName"
                className="input"
                name="userName"
                placeholder="Username"
                onChange={handleOnChangeInput}
                required
                onBlur={handOnBlurInput}
                isInvalid={errors.userName}
              />
              {errors.userName && (
                <Form.Control.Feedback type="invalid">
                  {errors.userName.type === "required" &&
                    "Please enter your username"}
                </Form.Control.Feedback>
              )}
              <Form.Control
                size="lg"
                type="password"
                id="userPassword"
                className="input"
                name="userPassword"
                placeholder="Password"
                onChange={handleOnChangeInput}
                required
                onBlur={handOnBlurInput}
                isInvalid={errors.userPassword}
              />
              {errors.userPassword && (
                <Form.Control.Feedback type="invalid">
                  {errors.userPassword.type === "required" &&
                    "Please enter your password"}
                </Form.Control.Feedback>
              )}

              {!!loginError && <div className="error">{loginError}</div>}

              <Button
                variant=""
                type="submit"
                size="lg"
                className="onLogin"
                disabled={isSubmitDisabled()}
              >
                Sign in
              </Button>
            </div>
          </Form>
          <div className="formFooter">
            <NavLink exact={true} to="/ForgotPassword" activeClassName="link">
              Forgot Password
            </NavLink>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default Login;
